import { render, staticRenderFns } from "./MeusAfiliados.vue?vue&type=template&id=40337dc6&scoped=true&"
import script from "./MeusAfiliados.vue?vue&type=script&lang=js&"
export * from "./MeusAfiliados.vue?vue&type=script&lang=js&"
import style0 from "./MeusAfiliados.vue?vue&type=style&index=0&id=40337dc6&prod&lang=css&"
import style1 from "./MeusAfiliados.vue?vue&type=style&index=1&id=40337dc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40337dc6",
  null
  
)

export default component.exports